import * as React from 'react';
import { Builder } from '@builder.io/react';
import { ThirdPartyContentBlockProps } from './ThirdPartyBlock';

const register = <TProps extends ThirdPartyContentBlockProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'ThirdPartyBlock',

		inputs: [
			{
				name: 'hideOnMobile',
				type: 'boolean',
				defaultValue: false,
			},
			{
				name: 'scriptUrlValue',
				type: 'url',
			},
			{
				name: 'scriptValue',
				type: 'javascript',
			},
			{
				name: 'cssUrlValue',
				type: 'url',
			},
			{
				name: 'cssValue',
				type: 'code',
			},
			{
				name: 'htmlValue',
				type: 'code',
			},
		],
	});
};

export default register;
